import React, { Suspense } from "react";

const NotFound = React.lazy(() => import("@/pages/not-found"));

export default function NotFoundContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <NotFound />
    </Suspense>
  );
}
